import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import loading from './loading.reducer';
import language from './language.reducer';
import errors from './errors.reducer';
import session from './session.reducer';
import imageUpload from './imageUpload.reducer';
import countries from './countries/countries.reducer';
import productTours from './productTours/productTours.reducer';
import mocks from './mocks/mockAccess.reducer';
import warning from './warning/warning.reducer';

export const appReducer = combineReducers({
  loading,
  language,
  errors,
  session,
  imageUpload,
  countries,
  productTours,
  mocks,
  warning,
});

/*
  here we will cache thee language reducer in order to give
  redux persist responsibility for the caching and persistence
  making it automated the process of caching and we can
  always access the data from a single source of truth: the reducer
*/
const languageReducerPersistConfig = {
  key: 'language',
  storage,
  blacklist: ['loading', 'errors', 'session', 'imageUpload', 'mocks', 'productTours', 'warning'],
};

export default persistReducer(languageReducerPersistConfig, appReducer);
